import React, { useEffect, useState } from "react";

const CountingComponent = () => {
  const [count, setCount] = useState(1);
  const [timeCompleted, setTimeCompleted] = useState(0);
  let totalTimes = 0;

  useEffect(() => {
    if (count <= 10) {
      if (count === 10) {
        return;
      }

      const timer = setTimeout(() => {
        setCount((prevCount) => prevCount + 1);
      }, calculateInterval());

      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  const calculateInterval = () => {
    const totalTime = 210000; 
    const timePerStep = totalTime / 10; 

    // const randomTime = Math.random() * timePerStep;
    const randomTime =
      Math.floor(Math.random() * (timePerStep - 15000 + 1)) + 15000;


    let randomTimeCount = 0;
    if (count === 9) {
      randomTimeCount = totalTime - timeCompleted;
    } else {
      randomTimeCount = randomTime > 100 ? randomTime : 100;
    }

    totalTimes += randomTimeCount; // Accumulate randomTimeCount into totalTimes variable
    setTimeCompleted((prevTime) => prevTime + totalTimes); // Update timeCompleted with the accumulated time

    return randomTimeCount; // Return the calculated randomTimeCount as the interval
  };

  return <>{count}</>;
};

export default CountingComponent;
